import { createCrudPage } from './factories/crud-page.js';
import { bannersCards } from './banners-cards/banners-cards.js';
import { bannersConfig } from './banners-config.js';

// Strip mode (default): overview + by-type cards above a standalone table.
export default createCrudPage(bannersConfig({ cards: bannersCards }));
